import React from 'react';
import { StyleSheet } from 'react-native';
import { SettingsItem } from 'design-system/SettingsItem';
import { IconEdit, rem } from 'design-system';
import Modal from 'utils/packages/Modal';
import { navigationRef } from 'utils/navigationv6';
import { IconBoldCalendar } from 'design-system/icons';
import { isWeb } from '../../../constants';
const ManageAnalyticsModalContent = () => (<>
    <SettingsItem icon={<IconBoldCalendar gradientKey="skyBlue"/>} title="Edit period" onPress={() => {
        Modal.hide(() => navigationRef.navigateDeprecated('SelectPeriod', {
            flow: 'SetAnalytics',
        }));
    }}/>
    <SettingsItem icon={<IconEdit colorKey="brand"/>} title="Manage custom categories" onPress={() => {
        Modal.hide(() => navigationRef.navigateDeprecated('ManageCategories'));
    }}/>
  </>);
export const ManageAnalyticsModal = {
    show: () => {
        Modal.show(<ManageAnalyticsModalContent />, {
            containerStyle: styles.modal,
            title: 'Manage analytics',
            textStyle: styles.textStyle,
        });
    },
    hide: Modal.hide,
};
const styles = StyleSheet.create({
    modal: {
        ...(!isWeb && {
            paddingHorizontal: 0,
        }),
    },
    textStyle: {
        marginBottom: rem(8),
    },
});
